import { Link } from 'react-router-dom';

import Icon from 'components/Icon';

import { medicareEnrollLogoBlueBackroundWAlt } from 'utilities/altText';

import image from './image.svg';

import styles from './styles.module.scss';

const InverseLogo = ({ className = '', linkClassName = '' }) => (
    <Link
        className={`${styles.logo} ${linkClassName}`}
        data-click-type="link"
        to="/"
        onClick={() => {
            window.scrollTo(0, 0);
        }}
    >
        <Icon
            alt={medicareEnrollLogoBlueBackroundWAlt}
            className={`${styles.inverseLogo} ${className}`}
            image={image}
        />
    </Link>
);

export default InverseLogo;
